import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MoonIcon, SunIcon } from "../../../assets/Svg/SvgImages.jsx";
import { setTheme } from "../../../features/persist/persistSlice";
import { applyDocumentTheme, DARK_THEMES, getPreferredDarkTheme, getThemeConfig, isDarkUiTheme, normalizeTheme } from "../../../helpers/themeHelper";
import "./ThemePalette.scss";
const ThemePalette = () => {
  const dispatch = useDispatch();
  const theme = normalizeTheme(useSelector(state => state.persist.theme));
  const isDark = isDarkUiTheme(theme);
  const [paletteOpen, setPaletteOpen] = useState(false);
  const rootRef = useRef(null);
  const applyTheme = nextTheme => {
    const next = normalizeTheme(nextTheme);
    applyDocumentTheme(next);
    dispatch(setTheme(next));
  };
  const handleModeToggle = () => {
    if (isDark) {
      applyTheme("light");
      setPaletteOpen(false);
      return;
    }
    applyTheme(getPreferredDarkTheme());
    setPaletteOpen(true);
  };
  const handleSelectDark = themeId => {
    applyTheme(themeId);
    setPaletteOpen(true);
  };
  useEffect(() => {
    if (!paletteOpen) return undefined;
    const onPointerDown = event => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setPaletteOpen(false);
      }
    };
    const onKeyDown = event => {
      if (event.key === "Escape") setPaletteOpen(false);
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [paletteOpen]);
  useEffect(() => {
    if (!isDark) setPaletteOpen(false);
  }, [isDark]);
  const current = getThemeConfig(theme);
  return <div className="themePalette" ref={rootRef}>
      <button type="button" className={`theme_btn themePalette__toggle${isDark ? " active" : ""}${theme === "black" ? " theme_btn--black" : ""}`} onClick={handleModeToggle} aria-label={isDark ? "Switch to light theme" : "Switch to dark theme and choose palette"} title={isDark ? "Switch to light" : "Switch to dark"}>
        {isDark ? <MoonIcon /> : <SunIcon />}
      </button>

      {isDark && <button type="button" className={`themePalette__swatchBtn${paletteOpen ? " is-open" : ""}`} onClick={() => setPaletteOpen(open => !open)} aria-expanded={paletteOpen} aria-haspopup="listbox" aria-label="Choose dark color palette" title="Dark color palette">
          <span className="themePalette__swatchPreview" style={{
        background: `linear-gradient(135deg, ${current.swatch.bg} 0 45%, ${current.swatch.surface} 45% 75%, ${current.swatch.accent} 75% 100%)`
      }} />
        </button>}

      {isDark && paletteOpen && <div className="themePalette__popover" role="listbox" aria-label="Dark themes">
          <p className="themePalette__title">Dark palette</p>
          <div className="themePalette__grid">
            {DARK_THEMES.map(item => {
          const selected = item.id === theme;
          return <button key={item.id} type="button" role="option" aria-selected={selected} className={`themePalette__option${selected ? " is-selected" : ""}`} onClick={() => handleSelectDark(item.id)} title={item.label}>
                  <span className="themePalette__swatch" style={{
              background: `linear-gradient(135deg, ${item.swatch.bg} 0 45%, ${item.swatch.surface} 45% 75%, ${item.swatch.accent} 75% 100%)`
            }} />
                  <span className="themePalette__label">{item.label}</span>
                </button>;
        })}
          </div>
        </div>}
    </div>;
};
export default ThemePalette;